import Repository from './Repository';
const resource = '/content/tab-order';

export default {
  get() {
    return Repository.get(`${resource}`);
  }
};
